"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FieldSelectAdapter = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FieldSelect = require("../microFields/FieldSelect");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FieldSelectAdapter = function FieldSelectAdapter(_ref) {
  var field = _ref.field,
      label = _ref.label,
      children = _ref.children,
      isRequiredField = _ref.isRequiredField,
      isInvalid = _ref.isInvalid,
      transparent = _ref.transparent,
      isCentered = _ref.isCentered,
      doFocus = _ref.doFocus;
  return _react.default.createElement(_FieldSelect.FieldSelect, _extends({}, field, {
    name: field.name,
    label: label,
    isRequiredField: isRequiredField,
    isInvalid: isInvalid,
    transparent: transparent,
    isCentered: isCentered,
    doFocus: doFocus
  }), children);
};

exports.FieldSelectAdapter = FieldSelectAdapter;
FieldSelectAdapter.defaultProps = {
  label: '',
  isRequiredField: true,
  isInvalid: false,
  transparent: false,
  isCentered: false,
  doFocus: false
};
FieldSelectAdapter.propTypes = {
  field: _propTypes.default.object.isRequired,
  label: _propTypes.default.string,
  children: _propTypes.default.node.isRequired,
  isRequiredField: _propTypes.default.bool,
  isInvalid: _propTypes.default.bool,
  transparent: _propTypes.default.bool,
  isCentered: _propTypes.default.bool,
  doFocus: _propTypes.default.bool
};